import { Link } from "react-router-dom";
import { recommendedComics } from "@/mocks/comics";

export default function Recommended() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-12">
      <div className="flex items-center justify-between mb-6">
        <h3
          className="text-xl md:text-2xl font-bold text-foreground-950"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          编辑推荐
        </h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {recommendedComics.map((comic) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.slug}`}
            className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/20 transition-all duration-200"
          >
            <div className="w-24 h-32 flex-shrink-0 rounded-lg overflow-hidden">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="flex flex-col justify-between min-w-0">
              <div>
                <h4 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h4>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-500">{comic.author}</span>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                    {comic.genre}
                  </span>
                </div>
                <p className="text-xs text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                  {comic.desc}
                </p>
              </div>
              <span className="text-xs text-primary-500 font-medium mt-2 inline-flex items-center gap-1 whitespace-nowrap">
                立即阅读 <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}